module.exports = "<view-header></view-header>\n\n<facturas_search_boxes></facturas_search_boxes>"